const STORAGE_KEY = 'fc.referralCode';
const AGENT_STORAGE_KEY = 'fc.agentCode';
const PROMPTED_KEY = 'fc.referralPrompted';

function publicBase() {
  const base = import.meta.env.BASE_URL || '/';
  return base.endsWith('/') ? base : `${base}/`;
}

export function persistReferralCode(code: string) {
  const trimmed = code.trim();
  if (!trimmed || typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(STORAGE_KEY, trimmed);
}

export function persistAgentCode(code: string) {
  const trimmed = code.trim();
  if (!trimmed || typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(AGENT_STORAGE_KEY, trimmed);
}

export function storedReferralCode() {
  if (typeof sessionStorage === 'undefined') return '';
  return sessionStorage.getItem(STORAGE_KEY)?.trim() || '';
}

export function storedAgentCode() {
  if (typeof sessionStorage === 'undefined') return '';
  return sessionStorage.getItem(AGENT_STORAGE_KEY)?.trim() || '';
}

export function consumeReferralLandingPrompt() {
  if (typeof sessionStorage === 'undefined') return false;
  if (sessionStorage.getItem(PROMPTED_KEY)) return false;
  sessionStorage.setItem(PROMPTED_KEY, '1');
  return true;
}

export function referralCodeFromQuery(query: Record<string, unknown>) {
  const share = query.share_code;
  const ref = query.ref;
  if (typeof share === 'string' && share.trim()) return share.trim();
  if (typeof ref === 'string' && ref.trim()) return ref.trim();
  return '';
}

export function agentCodeFromQuery(query: Record<string, unknown>) {
  const agent = query.agent;
  return typeof agent === 'string' && agent.trim() ? agent.trim() : '';
}

/** 注册框展示：代理链接优先，否则玩家邀请码。 */
export function inviteFieldValue(referralCode = '', agentCode = '') {
  return agentCode.trim() || referralCode.trim();
}

export function inviteFieldLocked(referralCode = '', agentCode = '') {
  return Boolean(inviteFieldValue(referralCode, agentCode));
}

/** 代理落地码只走 agentCode，不能当玩家邀请码提交。 */
export function referralCodeForRegister(
  formCode: string,
  lockedReferral = '',
  lockedAgent = '',
) {
  const referral = lockedReferral.trim();
  if (referral) return referral;
  if (lockedAgent.trim()) return '';
  return formCode.trim();
}

export function inviteShareCode(player?: { publicPlayerId?: string } | null) {
  return player?.publicPlayerId?.trim() || '';
}

export function buildInviteLink(referralCode: string) {
  const origin = typeof window === 'undefined' ? '' : window.location.origin;
  const code = referralCode.trim();
  return `${origin}${publicBase()}?share_code=${encodeURIComponent(code)}`;
}
